import axiosInstance from "../services/secureApi";

export const getTestimonials = async (page = 1, limit = 10) => {
  const response = await axiosInstance.get(`/admin/testimonials/list`, {
    params: { page, limit },
  });
  return response.data;
};

/* ================= GET APPROVED TESTIMONIALS ================= */
export const getApprovedTestimonialsApi = async () => {
  try {
    const response = await axiosInstance.get(
      "/admin/testimonials/list/approved"
    );

    return response.data;
  } catch (error) {
    console.error(
      "Get Approved Testimonials Error:",
      error.response?.data
    );
    throw error;
  }
};

export const approveTestimonial = async (id) => {
  const response = await axiosInstance.put(`/admin/approve/${id}`);
  return response.data;
};

export const disapproveTestimonial = async (id) => {
  const response = await axiosInstance.put(`/admin/disapprove/${id}`);
  return response.data;
};